// const axios = require('axios').default
import axios from 'axios'

// Use API URL from environment variable
const API_URL = process.env.REACT_APP_API_URL
console.log('API_URL', API_URL)
export { API_URL }

// Create axios instance without setting the Authorization header initially
const server = axios.create({
  baseURL: API_URL,
})

// Add a request interceptor to dynamically set the token for every request
server.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

export default server
